import { render, staticRenderFns } from "./ChartComponent.vue?vue&type=template&id=54a3a653&"
import script from "./ChartComponent.vue?vue&type=script&lang=js&"
export * from "./ChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports